import React, { useState } from "react";
import { useAuth } from "../context/auth";
import { useNavigate } from "react-router-dom";

export default function Register({ returnToLanding }) {
  const { register, authError, clearError, setAuthError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    clearError();
    e.preventDefault();
    if (email && password && displayName) {
      register(email, password, displayName);
      navigate("/");
    } else {
      setAuthError("Please fill out all fields.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="column">
      <div className="column form-margin">
        <input
          type="email"
          value={email}
          onChange={(e) => {
            clearError();
            setEmail(e.target.value);
          }}
          placeholder="Email"
        />
        <input
          type="text"
          value={displayName}
          onChange={(e) => {
            clearError();
            setDisplayName(e.target.value);
          }}
          placeholder="Display name (public)"
        />
        <input
          type="password"
          value={password}
          onChange={(e) => {
            clearError();
            setPassword(e.target.value);
          }}
          placeholder="Password"
        />
      </div>

      <button className="form-margin" type="submit">
        REGISTER
      </button>
      <button type="button" onClick={returnToLanding}>
        back
      </button>
      {authError && <div className="notice">{authError}</div>}
    </form>
  );
}
